// Tiny cross-tree bridge: AuthContext (above InfiniteCanvas in the component
// tree) cannot call InfiniteCanvas's persistLocalDraft directly via props, so
// InfiniteCanvas registers it here on mount and AuthContext's forced-logout
// path calls triggerDraftSave() right before signOut. A no-op if nothing is
// registered (e.g. the user is on a page with no open canvas session).

let saveFn = null;

export function registerDraftSaver(fn) {
  saveFn = fn;
}

export function unregisterDraftSaver() {
  saveFn = null;
}

export function triggerDraftSave() {
  if (saveFn) saveFn();
}
